var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIncomeIcon2 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#7D7D7D",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.994 13.622c0 .19-.169.374-.41.375h-5.177c-.24-.001-.41-.184-.41-.375v-2.245c0-.192.17-.374.41-.375h5.177c.241 0 .41.183.41.375v2.245zM18.615 19H2.365a.364.364 0 0 1-.37-.357V6.002h16.603c.232.002.392.176.393.357v3.64h-4.584c-.765 0-1.41.6-1.413 1.378v2.245c.003.777.648 1.376 1.413 1.378h4.578v3.643c0 .192-.16.357-.37.357zm-3.15-16.491.086-.01c.122 0 .235.05.317.129a.4.4 0 0 1 .127.295v2.079H4.255l11.21-2.493zm4.526 7.556V6.359c-.003-.766-.639-1.356-1.393-1.357h-1.603v-2.08c-.003-.81-.67-1.42-1.444-1.422-.09 0-.184.009-.276.026l-.008.002-13.19 2.934A1.362 1.362 0 0 0 .995 5.79V18.643A1.365 1.365 0 0 0 2.365 20h16.25a1.364 1.364 0 0 0 1.37-1.357v-3.707c.576-.168 1.01-.68 1.012-1.314v-2.245c-.003-.633-.433-1.142-1.006-1.312z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.51 11.513a.999.999 0 0 0-1 .996 1 1 0 0 0 2 0 1 1 0 0 0-1-.996"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIncomeIcon2);
export default ForwardRef;